
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"55","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#005149","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M26.755 53.048c-13.924 0-25.253-11.329-25.253-25.254S12.831 2.54 26.755 2.54c13.925 0 25.255 11.33 25.255 25.254S40.68 53.048 26.755 53.048m0-52.01C12.002 1.038 0 13.041 0 27.794S12.002 54.55 26.755 54.55c14.754 0 26.755-12.002 26.755-26.755 0-14.753-12.001-26.756-26.755-26.756"}}),_c('path',{attrs:{"d":"M12.19 28.047l6.453-6.41a.933.933 0 00-.665-1.596.933.933 0 00-.664.273l-7.12 7.072a.924.924 0 00-.275.66c0 .25.097.485.275.66l7.12 7.072c.167.168.417.25.664.263a.946.946 0 00.665-.263.924.924 0 00.276-.66.924.924 0 00-.276-.66l-6.454-6.411zm30.453-.66l-7.118-7.073a.937.937 0 00-.665-.273.942.942 0 00-.666.272.927.927 0 000 1.321l6.454 6.412-6.454 6.411a.924.924 0 00-.275.66.918.918 0 00.941.924.945.945 0 00.665-.263l7.118-7.071a.924.924 0 00.276-.66.92.92 0 00-.276-.66M29.166 16.068a1.03 1.03 0 00-.24-.027c-.457 0-.854.285-.964.693l-6.014 22.17a.856.856 0 00.112.693c.137.21.354.358.61.417.252.058.517.02.749-.107a.919.919 0 00.456-.56l6.014-22.17a.852.852 0 00-.111-.692.985.985 0 00-.612-.417"}})])])
          )
        }
      }
    